<p-toast></p-toast>

<p-dialog
    header="Usage Statistics"
    [modal]="true"
    [style]="{width: '95vw'}"
    [(visible)]="visible"
    (onHide)="closeDocumentsDialog()"
    [draggable]="false"
>
    <form class="form-datepicker" (ngSubmit)="loadCharts()">
        
        <div class="datepickerContainer">
            <label for="startDate">Start Date</label>
            <p-calendar
                [(ngModel)]="startDate"
                id="startDate"
                class="datepicker"
                name="startDate"
                dateFormat="mm/dd/yy"
                placeholder="Select Start Date"
                required
                [maxDate]="maxDate"
            ></p-calendar>
        </div>

        <div class="datepickerContainer">
            <label for="endDate">End Date</label>
            <p-calendar
                [(ngModel)]="endDate"
                class="datepicker"
                id="endDate"
                name="endDate"
                dateFormat="mm/dd/yy"
                placeholder="Select End Date"
                required
                [maxDate]="maxDate"
            ></p-calendar>
        </div>

        <span class="form-btn-submit">
            <button
                type="submit"
                pButton
                label="Submit"
                class="p-button p-button-primary btnPadding"
                [disabled]="!startDate || !endDate || isStartDateAfterEndDate()"
            ></button>

        </span>
        <div *ngIf="startDate && endDate && isStartDateAfterEndDate()" class="text-danger flex justify-content-end">
            <p>Start Date cannot be later than End Date.</p>
        </div>

    </form>

    @if(isLoading) {
    <div class="chart-loader" *ngIf="isLoading;">
        <p-progressSpinner></p-progressSpinner>
    </div>
    }

    <!-- 130, 250, 400 -->
    @if (!isLoading) {
        <div class="stats-container">
            

            <div class="stats-summary stats-summary-all">

                <div class="loaderContainer" *ngIf="chatInfoloader">
                    <div class="loaderSpinner"></div>
                </div>

                <div *ngIf="!chatInfoloader" class="flex justify-content-center align-items-center p-2">
                    <div [innerHTML]="chatInfo?.window"></div>
                </div>

            </div>

            <div class="stats-summary stats-summary-interactions">

                <div class="loaderContainer" *ngIf="chatInfoloader">
                    <div class="loaderSpinner"></div>
                </div>

                <div *ngIf="!chatInfoloader">
                    <div [innerHTML]="chatInfo.total"></div>
                </div>

            </div>


            <div class="stats-power-users">

                <div class="loaderContainer" *ngIf="powerUserLoader">
                    <div class="loaderSpinner"></div>
                </div>

                <app-data-table *ngIf="!powerUserLoader"
                    [startDate]="startDate"
                    [endDate]="endDate"
                    [tableData]="powerUsersData"
                ></app-data-table>

            </div>

            <div class="stats-graph-interactions">
                <app-bar-chart class="p-3" [chatResp]="interactionsVsTime"></app-bar-chart>
            </div>


            <div class="stats-graph-users">
                <app-bar-chart class="p-3" [chatResp]="UsersVsTime"></app-bar-chart>
            </div>

        </div>
    }

</p-dialog>
